import React, { createContext, useContext, useMemo } from 'react';

const defaultFlags = {
  adaptivePractice: true,
  smartHome: true,
  newTestsUI: true,
  analyticsV1: true,
};

const FeatureFlagsContext = createContext(defaultFlags);

export const FeatureFlagsProvider = ({ children }) => {
  const flags = useMemo(() => {
    try {
      const raw = localStorage.getItem('ff_overrides');
      if (!raw) return defaultFlags;
      const ov = JSON.parse(raw);
      return { ...defaultFlags, ...(ov || {}) };
    } catch {
      return defaultFlags;
    }
  }, []);

  return (
    <FeatureFlagsContext.Provider value={flags}>{children}</FeatureFlagsContext.Provider>
  );
};

export const useFeatureFlags = () => useContext(FeatureFlagsContext);


